import React from 'react';
import PropTypes from 'prop-types';

import ButtonBase from '@material-ui/core/ButtonBase';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';

import { withStyles } from '@material-ui/core/styles';
import styles from './styles.js';

class ViewMoreLink extends React.Component {
  constructor(props) {
    super(props);
    this.handleActionClick = this.handleActionClick.bind(this);
  }

  handleActionClick(e) {
    const { action } = this.props;
    action();
    e.preventDefault();
  }

  render() {
    const { classes, label, standAlone } = this.props;

    return (
      <ButtonBase
        className={
          standAlone
            ? `${classes.root} ${classes.buttonLink} ${classes.standAlone}`
            : `${classes.root} ${classes.buttonLink}`
        }
        onClick={this.handleActionClick}
      >
        {label}
      </ButtonBase>
    );
  }
}

ViewMoreLink.propTypes = {
  classes: PropTypes.object.isRequired,
  label: PropTypes.string.isRequired,
  action: PropTypes.func.isRequired,
  standAlone: PropTypes.bool,
};

ViewMoreLink.defaultProps = {
  standAlone: false,
};

export default withStyles(styles)(ViewMoreLink);
